/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { dataRemovalRequestDataDecisionSourceSchema } from './DataRemovalRequestDataDecisionSourceSchema'
import { dataRemovalRequestDataStatusSchema } from './DataRemovalRequestDataStatusSchema'

export const dataRemovalRequestDataSchema = z.object({
	id: z.string(),
	candidateId: z.string(),
	organisationId: z.string(),
	status: dataRemovalRequestDataStatusSchema,
	decisionSource: dataRemovalRequestDataDecisionSourceSchema,
	requestedAt: z.string(),
	notifiedAt: z.string().nullable(),
	decidedAt: z.string().nullable(),
	decidedByUserId: z.string().nullable(),
	rejectionReason: z.string().nullable(),
	completedAt: z.string().nullable(),
})

export type DataRemovalRequestDataSchema = z.infer<typeof dataRemovalRequestDataSchema>
